import { LANGUAGE, STEEL_CATEGORY } from '../../constants';
import { Language, SteelCategory } from '../../types/common';
import type { OptionsType } from '../../types/options';

/**
 * @param selectedSteelCategory: [SteelCategory]
 * @param language: [Language]
 * @returns [string]
 */
const getSteelCategoryQuery = (selectedSteelCategory: SteelCategory | '', steelCategoryType: OptionsType<SteelCategory, string>[], language: Language): string => {
  const barWireRod = steelCategoryType.find((option) => option.code === STEEL_CATEGORY.BAR)?.children ?? [];
  const sheetSteel = steelCategoryType.find((option) => option.code === STEEL_CATEGORY.PLATE)?.children ?? [];
  const pipe = steelCategoryType.find((option) => option.code === STEEL_CATEGORY.PIPE)?.children ?? [];
  const queryBarWireRodJa: string = '品種:(' + barWireRod.map((child) => child.nameJapanese).join(' OR ') + ')';
  const querySheetSteelJa: string = '品種:(' + sheetSteel.map((child) => child.nameJapanese).join(' OR ') + ')';
  const queryPipeJa: string = '品種:(' + pipe.map((child) => child.nameJapanese).join(' OR ') + ')';
  const queryBarWireRodEn: string = '品種_EN:(' + barWireRod.map((child) => child.nameEnglish).join(' OR ') + ')';
  const querySheetSteelEn: string = '品種_EN:(' + sheetSteel.map((child) => child.nameEnglish).join(' OR ') + ')';
  const queryPipeEn: string = '品種_EN:(' + pipe.map((child) => child.nameEnglish).join(' OR ') + ')';

  if (language === LANGUAGE.JA) {
    if (selectedSteelCategory === STEEL_CATEGORY.BAR) {
      return queryBarWireRodJa;
    } else if (selectedSteelCategory === STEEL_CATEGORY.PLATE) {
      return querySheetSteelJa;
    } else if (selectedSteelCategory === STEEL_CATEGORY.PIPE) {
      return queryPipeJa;
    } else {
      return '';
    }
  } else if (language === LANGUAGE.EN) {
    if (selectedSteelCategory === STEEL_CATEGORY.BAR) {
      return queryBarWireRodEn;
    } else if (selectedSteelCategory === STEEL_CATEGORY.PLATE) {
      return querySheetSteelEn;
    } else if (selectedSteelCategory === STEEL_CATEGORY.PIPE) {
      return queryPipeEn;
    } else {
      return '';
    }
  } else {
    return '';
  }
};

export default getSteelCategoryQuery;
